

























import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import {
  both, includes, filter, sortBy, sortWith, prop, descend, ascend,
} from 'ramda'
import firebase from 'firebase'

import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import dayjs from 'dayjs'
import {
  getModule,
} from 'vuex-module-decorators'
import { db } from '../../firebase/init'
import { DisplaySlideType, DisplayBoardType, SlideDetailsType } from '../../types'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import UUID from '../../helpers/system/uuid'
import slug from '../../helpers/system/slug'

// Collections
import { DisplayBoardCollection, DisplaySlideCollection } from '../../helpers/collections'
// Filter Functions

@Component({
  components: {
  },
})

export default class NewSlide<T extends Vue> extends Mixins(MainMixin) {
  @Prop({ default: null }) activeBoard!:DisplayBoardType|null

  hourList = [
    { text: '12am', value: 0 },
    { text: '1am', value: 1 },
    { text: '2am', value: 2 },
    { text: '3am', value: 3 },
    { text: '4am', value: 4 },
    { text: '5am', value: 5 },
  ]

  $refs:any

  loading = false

  newBoard:DisplayBoardType = {
    name: '',
    description: '',
    landscape: false,
    slides: [],
    startHour: 0,
    created: new Date(),
    text: [],
    settings: {},
    location: this.location,
  }

  resetNewBoard() {
    this.newBoard = {
      name: '',
      description: '',
      landscape: false,
      slides: [],
      startHour: 0,
      created: new Date(),
      text: [],
      settings: {},
      location: this.location,
    }
    this.$refs.obs.reset()
  }

  created() {
    this.newBoard.location = this.location
  }

  // Create Board - Slugify name, and creates if does not exist
  async createBoard() {
    this.loading = true
    const tempId = slug(this.newBoard.name)
    const exists = await get(DisplayBoardCollection, tempId)
    if (exists) {
      this.$toast.error(`Board with name ${this.newBoard.name} already exists!`)
      this.newBoard.name = ''
      this.loading = false
      return false
    }
    this.newBoard.created = new Date()
    const result = await set(DisplayBoardCollection, tempId, this.newBoard)
    console.log('result: ', result)
    this.$toast.success(`New ${this.newBoard.name} Board Successfully Added`)
    this.loading = false
    this.resetNewBoard()
    this.makeactive(tempId)
    return this.display('boards', 'singleBoard')
  }

  @Emit()
  makeactive(id:string) {
    return id
  }

  @Emit()
  display(tab:string, section:string) {
    return [tab, section]
  }
}

